import { useRouter } from '@atlassian/react-resource-router';

export const useIsEmbed = (): boolean => {
	const [
		{
			location: { pathname },
		},
	] = useRouter();

	if (pathname.endsWith('/embed')) {
		return true;
	}
	return false;
};
